module.exports = __webpack_public_path__ + "static/media/icon-money.38febf51.svg";